import { IApplicationState } from '../../types/redux';

export const selectPuids = (state: IApplicationState) => state.listingOffers.puids;
